import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, User } from 'lucide-react';
import { useTrainingUser } from '../../hooks/useTrainingUser';

interface TrainingShellProps {
  children: React.ReactNode;
  showHeader?: boolean;
}

export default function TrainingShell({ children, showHeader = true }: TrainingShellProps) {
  const { user, logout } = useTrainingUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/capacitacion');
  };

  return (
    <div className="min-h-screen bg-ngs-bg text-white">
      {showHeader && (
        <header className="border-b border-ngs-cyan/20 bg-ngs-surface/80 backdrop-blur sticky top-0 z-10">
          <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
            <button
              onClick={() => navigate('/capacitacion/modulos')}
              className="text-lg font-bold tracking-wide"
            >
              <span className="text-ngs-cyan">SuMinuta</span>{' '}
              <span className="text-ngs-orange">Capacitación</span>
            </button>

            {user && (
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-2 text-sm text-gray-300">
                  <User className="h-4 w-4" />
                  <span>{user.nombre}</span>
                  <span className="text-gray-500">·</span>
                  <span className="text-ngs-cyan">{user.empresa}</span>
                </div>
                <button
                  onClick={handleLogout}
                  className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-ngs-magenta border border-gray-700 hover:border-ngs-magenta rounded-md px-3 py-1.5 transition-colors"
                >
                  <LogOut className="h-3 w-3" />
                  Cerrar sesión
                </button>
              </div>
            )}
          </div>
        </header>
      )}

      <main className="max-w-6xl mx-auto px-6 py-8">{children}</main>
    </div>
  );
}
